document.addEventListener('DOMContentLoaded', function() {

  function isOptionDisabledInAnySelector(textToFind, selectorClass) {
    const selects = document.querySelectorAll(selectorClass);
    let isDisabledAnywhere = false;
    const searchStr = textToFind.trim().toLowerCase();
    selects.forEach(select => {
      const options = Array.from(select.options);
      const targetOption = options.find(opt => opt.text.trim().toLowerCase() === searchStr);
      if (targetOption && targetOption.disabled) {
        isDisabledAnywhere = true;
      }
    });

    return isDisabledAnywhere;
  }
  function update_image_immersion(val){
    switch(val){
      case 'Santal and Cypress':
        document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-26_5f33e9e4-2a83-4936-9963-924b9676c9c5.jpg?v=1765568522&width=150"]').parentElement.click();
        break;
      case 'Saffron and Cedar':
        document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-48.jpg?v=1765568522&width=150"]').parentElement.click();
        break;
      case 'Stone and Leather':
        document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-46.jpg?v=1765568522&width=150"]').parentElement.click();
        break;
      case 'Oakmoss and Amber':
        document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-47.jpg?v=1765568522&width=150"]').parentElement.click();
        break;
      case 'Olive and Citron and Fig':
        document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-25_7cf532cd-69c0-4197-ab42-017cd6cee5d4.jpg?v=1765568522&width=150"]').parentElement.click();
        break;
      case 'Sea Salt and Orris and Sandalwood':
        document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-27_3fe54efe-61fe-4c8a-9c50-7d8b8613d760.jpg?v=1761094486&width=150"]').parentElement.click();
        break;
    }
  }
  function get_variation(url){
    if (window.location.pathname.indexOf('/collections/' + url) > -1){
      var immersionSet = document.querySelectorAll('.flex.grow.relative.h-full.w-full.z-10.overflow-hidden.md\\:rounded-\\[10px\\].rounded-\\[10px\\]');

      immersionSet.forEach(function(element) {
          var link = element.querySelector('a');
          if (link) {
              var separator = link.href.includes('?') ? '&' : '?';
              
              link.href += separator + 'variation=' + url;
          }
      });

      var alink = document.querySelectorAll('.ltr.group.link-product-variant.overflow-hidden.block.relative.z-\\[15\\].cursor-pointer.before\\:h-0.before\\:block.no-collage.rounded-\\[10px\\].pb-\\[150\\%\\]');
      alink.forEach(function(link) {
          if (link) {
              var separator = link.href.includes('?') ? '&' : '?';
              
              link.href += separator + 'variation=' + url;
          }
      });
    }
  }
  if (window.location.pathname.indexOf('/collections/olive-citron-fig') > -1){
    get_variation('olive-citron-fig');
  }
  if (window.location.pathname.indexOf('boyfriend') > -1){
    document.querySelector('.shopify-block.shopify-app-block').style.display = 'none';
  }
  if (window.location.pathname.indexOf('signature-set') > -1){
    document.querySelector('.shopify-block.shopify-app-block').style.display = 'none';
  }
  if (window.location.pathname.indexOf('/collections/santal-cypress') > -1){
    get_variation('santal-cypress');
  }
  if (window.location.pathname.indexOf('/collections/sea-salt-orris-sandalwood') > -1){
    get_variation('sea-salt-orris-sandalwood');
  }
  if (window.location.pathname.indexOf('/collections/saffron-cedar') > -1){
    get_variation('saffron-cedar');
  }
  if (window.location.pathname.indexOf('/collections/stone-leather') > -1){
    get_variation('stone-leather');
  }
  if (window.location.pathname.indexOf('/collections/oakmoss-amber') > -1){
    get_variation('oakmoss-amber');
  }
  if (window.location.pathname.indexOf('/products') > -1){
    const selectProducts = '[class*="collapsible-content-template"] button, [class*="x-block-collapsible-tab-collapsible-row-0"] button';
    
    document.querySelectorAll(selectProducts).forEach(button => {
        button.addEventListener('click', function(event) {
            if (!event.isTrusted) return;

            document.querySelectorAll(selectProducts).forEach(otherButton => {
                if (otherButton !== this) {
                    const sibling = otherButton.nextElementSibling;
                    if (sibling && !sibling.hasAttribute('hidden')) {
                        otherButton.click();
                    }
                }
            });
        });
    });

    var queryString = document.location.search;
    var urlParams = new URLSearchParams(queryString);
    var variantId = urlParams.get('variation');

 
    if (variantId){
      setTimeout(() => {
        var fieldset = document.querySelector('[id*="main-0"].product-form__input.pl-0.flex.flex-wrap.pb-4.md\\:pb-6.eurus.gap-x-1\\.5, #generalVariationContainer');
        switch (variantId) {
          case 'olive-citron-fig':
            fieldset.querySelector('input[value="Olive and Citron and Fig"]').click();
            break;
          case 'santal-cypress':
            fieldset.querySelector('input[value="Santal and Cypress"]').click();
            document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-26_5f33e9e4-2a83-4936-9963-924b9676c9c5.jpg?v=1765568522&width=150"]').parentElement.click();
            break;
          case 'sea-salt-orris-sandalwood':
            fieldset.querySelector('input[value="Sea Salt and Orris and Sandalwood"]').click();
            break;
          case 'saffron-cedar':
            fieldset.querySelector('input[value="Saffron and Cedar"]').click();
            fieldset.querySelector('input[value="Saffron and Cedar"]').parentElement.click();
            document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-48.jpg?v=1765568522&width=150"]').parentElement.click();
            break;
          case 'stone-leather':
            fieldset.querySelector('input[value="Stone and Leather"]').click();
            document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-46.jpg?v=1765568522&width=150"]').parentElement.click();
            break;
          case 'oakmoss-amber':
            fieldset.querySelector('input[value="Oakmoss and Amber"]').click();
            document.querySelector('[src="//better-ritual.com/cdn/shop/files/BetterRitual_Lifestyle_4x5-47.jpg?v=1765568522&width=150"]').parentElement.click();
            break;
          
          default:
            
        }
      }, 500);
    }
  }
  // Home Page ----------------
  if (window.location.pathname.indexOf('/') > -1){
    
    const buttonConfigs = [
        {
            url: "/products/fragrance-oil",
            selector: "#\\39 207350198497-template--20073477374177__e32885d8-0a8f-4c4f-8801-377d01cb7656 > div.md\\:list-layout\\:hidden > div.quick-view-container > div > button.button--quickview"
        },
        {
            url: "/products/candle",
            selector: "#\\39 207349870817-template--20073477374177__e32885d8-0a8f-4c4f-8801-377d01cb7656 > div.md\\:list-layout\\:hidden > div.quick-view-container > div > button.button--quickview"
        },
        {
            url: "/products/360-concentrate",
            selector: "#\\39 207342891233-template--20073477374177__e32885d8-0a8f-4c4f-8801-377d01cb7656 > div.md\\:list-layout\\:hidden > div.quick-view-container > div > button.button--quickview"
        },
        {
            url: "/products/immersion-set",
            selector: "#product-form-choose-option9210491142369201 > button.button.button--quickview"
        }
    ];

    buttonConfigs.forEach(config => {
        try {
            const originalButton = document.querySelector(config.selector);

            if (originalButton) {
                const newButton = originalButton.cloneNode(true);

                const nestedSpan = newButton.querySelector('span > span > span');
                if (nestedSpan) {
                    nestedSpan.textContent = "See Details";
                }

                newButton.addEventListener('click', function(e) {
                    e.preventDefault(); 
                    e.stopImmediatePropagation();
                    window.location.href = config.url;
                });

                originalButton.parentNode.replaceChild(newButton, originalButton);
                console.log("Success: Button updated and redirected to " + config.url);
            } else {
                console.warn("Warning: Button not found for " + config.url);
            }
        } catch (error) {
            console.error("Error processing selector for " + config.url, error);
        }
    });
  }


  // Immersion Set -----------------------
if (window.location.pathname.indexOf('/products/immersion-set') > -1) {

    // Ocultar selectores originales
    var immersionSet = document.querySelectorAll('.shopify-block.shopify-app-block #simple-bundles-io-options select');
    immersionSet.forEach(function(select) {
        select.classList.add('d-none'); // Cambiado a d-none por consistencia
    });

    // --- LÓGICA DE NOTAS (Actualizada a d-none) ---
    const noteItems = document.querySelectorAll('#ProductInfo-template--20073477701857__main > div > div:nth-child(10) .metafield-rich_text_field ul li');

    // Inicialmente: Ocultamos todos SALVO los 3 primeros
    if (noteItems.length > 0) {
        noteItems.forEach((li, i) => {
            if (i >= 3) {
                li.classList.add('d-none'); // AQUI: Se agrega d-none
            } else {
                li.classList.remove('d-none'); 
            }
        });
    }
    // ------------------------------------------------

    const referenceElement = document.querySelector('.shopify-block.shopify-app-block #simple-bundles-io-options');

    if (!document.querySelector('#generalVariationContainer')) {
        const newContainer = document.createElement('div');
        newContainer.id = "generalVariationContainer";
        referenceElement.before(newContainer);
    }

    var container1 = document.querySelector('#generalVariationContainer');
    container1.innerHTML = ''; 

    const firstSelect = document.querySelector('.shopify-block.shopify-app-block #simple-bundles-io-options select:nth-child(4)');

    const options = Array.from(firstSelect.options).map(opcion => {
        return {
            value: opcion.value,
            text: opcion.text.trim()
        };
    });

    const nameGroup = "generalVariationSelector";
    const activeClass = 'is-selected'; 

    let visualIndex = 0; // Índice para controlar los grupos de 3 notas

    options.forEach((opcion) => {
        
        if (opcion.text == 'Please select an option' || opcion.text == 'Fragrance Free'){
          return;  
        }
        
        // Aquí podrías agregar tu lógica de isOptionDisabledInAnySelector si la tienes definida
        
        const currentVisualIndex = visualIndex; 

        const wrapper = document.createElement('div');
        wrapper.style.marginBottom = "5px";

        const deleteWords = ["Fragrance Oil - ", "Core 360° Concentrate - ", "Candle - "];

        const result = deleteWords.reduce((text, delete_item) => {
          return text.replaceAll(delete_item, "");
        }, opcion.value);

        const label = document.createElement('label');
        label.htmlFor = `${nameGroup}_${currentVisualIndex}`;
        label.textContent = result.replace(/\s+/g, ' ').trim();

        const allSelects = document.querySelectorAll('#simple-bundles-io-options select');
        
        label.className = 'flex items-center outline-none cursor-pointer mb-0 pl-5 pr-5 pt-2 pb-2 border bg-[rgba(var(--background-color),1)] rounded-md radio-item transition-all duration-200'; 

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = nameGroup;
        radio.className = 'radio-hidden'; 
        
        radio.value = result.replace(/\s+/g, ' ').trim();
        radio.id = `${nameGroup}_${currentVisualIndex}`;
        container1 = document.querySelector('#generalVariationContainer');

        radio.addEventListener('change', function() {
            const allLabels = container1.querySelectorAll('label.radio-item');
            const selectedValue = this.value;

            allLabels.forEach(lbl => lbl.classList.remove(activeClass, 'border-black', 'bg-gray-100'));
            this.parentElement.classList.add(activeClass, 'border-black', 'bg-gray-100');
            firstSelect.value = this.value;
            firstSelect.dispatchEvent(new Event('change', { bubbles: true }));

            allSelects.forEach(selectElement => {
              console.log([...selectElement.options].map(o => o.value), selectedValue);
                if ( matchingOption = [...selectElement.options].find(o => o.value.includes(selectedValue)) ){
                  console.log(matchingOption.value);
                  selectElement.value = matchingOption.value;
                  selectElement.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });        
            if (typeof update_image_immersion === "function") {
                update_image_immersion(this.value);
            }
            if (noteItems.length > 0) {
                const start = currentVisualIndex * 3; 
                const end = start + 3;

                noteItems.forEach((li, liIndex) => {
                    if (liIndex >= start && liIndex < end) {
                        li.classList.remove('d-none');
                    } else {
                        li.classList.add('d-none');
                    }
                });
            }
            // -----------------------------------------------------
        });

        if (currentVisualIndex === 0) {
            radio.checked = true;
            label.classList.add(activeClass, 'border-black', 'bg-gray-100');
        }

        label.style.marginLeft = "5px";
        
        label.appendChild(radio);
        wrapper.appendChild(label);
        container1.appendChild(wrapper);

        visualIndex++;
    });
}
  // Sample Set ---------------------
  if (window.location.pathname.indexOf('/products/sample-set') > -1) {
    
    var hiddenSelects = document.querySelectorAll('#simple-bundles-io-options select');

    hiddenSelects.forEach(function(select, index) {
      if (select.options[index + 1]) {
        select.value = select.options[index + 1].value;
      }
      select.style.display = 'none'; 
    });

    function refreshAvailability() {
      var takenValues = [];
      var allCheckedRadios = document.querySelectorAll('.generated-radio-group input[type="radio"]:checked');
      
      allCheckedRadios.forEach(function(radio) {
        if (radio.value) {
          takenValues.push(radio.value);
        }
      });

      var allRadios = document.querySelectorAll('.generated-radio-group input[type="radio"]');
      
      allRadios.forEach(function(radio) {
        var parentLabel = radio.closest('label');
        var value = radio.value;
        var isChecked = radio.checked;

        if (isChecked) {
          parentLabel.classList.add('is-selected');
        } else {
          parentLabel.classList.remove('is-selected');
        }

        if (takenValues.indexOf(value) > -1 && !isChecked) {
          radio.disabled = true;
          parentLabel.classList.add('is-disabled');
        } else {
          radio.disabled = false;
          parentLabel.classList.remove('is-disabled');
        }
      });
    }

    hiddenSelects.forEach(function(select) {
      var groupDiv = document.createElement('div');
      groupDiv.className = 'generated-radio-group';
      
      var originalLabel = document.querySelector('label[for="' + select.id + '"]');
      if (originalLabel) {
        originalLabel.style.fontWeight = 'bold';
        originalLabel.style.display = 'block';
        originalLabel.style.marginBottom = '10px';
        groupDiv.appendChild(originalLabel);
      }

      Array.from(select.options).forEach(function(option) {
        if (!option.value) return; 

        var label = document.createElement('label');
        label.className = 'flex items-center outline-none cursor-pointer mt-2.5 pl-5 pr-5 pt-2 pb-2 border bg-[rgba(var(--background-color),1)] rounded-md radio-item';
        
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'custom-group-' + select.id; 
        input.value = option.value;

        if (select.value === option.value) {
          input.checked = true;
        }

        input.addEventListener('change', function() {
          select.value = this.value; 
          select.dispatchEvent(new Event('change', { bubbles: true })); 
          refreshAvailability(); 
        });

        var text = document.createTextNode(option.text);
        
        label.appendChild(input);
        label.appendChild(text);
        groupDiv.appendChild(label);
      });

      select.parentNode.insertBefore(groupDiv, select);
    });

    //refreshAvailability();
  }
  if (window.location.pathname.indexOf('/collections') > -1){

    var url = '';

    if (document.location.href.includes('360-concentrate')){
      url = 'https://better-ritual.com/products/360-concentrate';
    } else if(document.location.href.includes('fragrance-oil')){
      url = 'https://better-ritual.com/products/fragrance-oil';
    } else if(document.location.href.includes('immersion-set')){
      url = 'https://better-ritual.com/products/immersion-set';
    }
    const urlsPorGrupo = {
        0: url + "?variation=olive-citron-fig", 
        1: url + "?variation=santal-cypress",
        2: url + "?variation=sea-salt-orris-sandalwood",
        3: url + "?variation=saffron-cedar",
        4: url + "?variation=stone-leather",
        5: url + "?variation=oakmoss-amber",
    };

    var container = document.querySelector('[class="w-full h-full splide__list md:grid md:grid-cols-6 flex w-full gap-grid--template--20073477112033__media_gallery_fXyUzM"]');
    if (container) {
        var items = container.querySelectorAll('a');

        for (let i = 0; i < items.length; i += 2) {
            
            let grupoIndex = i / 2;

            let urlDestino = urlsPorGrupo[grupoIndex] || urlsPorGrupo['default'];

            if (items[i]) {
                items[i].setAttribute('href', urlDestino);
            }

            if (items[i + 1]) {
                items[i + 1].setAttribute('href', urlDestino);
            }
        }
    }

  }
});



